import useTranslation from 'next-translate/useTranslation';
import type { SlateLabelEnum } from '@betterpool/api-types';
import { useState } from 'react';

import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';

import useGetSegmentedLabel from './useSegmentedLabel';

export const enum SegmentTab {
  OVERALL = 'overall',
  SEGMENT = 'segment',
}

type UseSegmentedTabs = {
  slates: ContestSlate[];
  overallLength: number;
  slateLabel?: SlateLabelEnum;
};

const useSegmentedTabs = ({ slateLabel, slates, overallLength }: UseSegmentedTabs) => {
  const { t } = useTranslation('contest');
  const [activeTab, setActiveTab] = useState<SegmentTab>(SegmentTab.OVERALL);

  const segmentLabel = useGetSegmentedLabel({
    slates,
    slateLabel,
  });

  const tabs = [
    {
      label: t('detail.schedule.tabs.overall', { value: overallLength }),
      value: SegmentTab.OVERALL,
    },
    { label: segmentLabel, value: SegmentTab.SEGMENT },
  ];

  return { tabs, activeTab, setActiveTab };
};

export default useSegmentedTabs;
